module.exports = __webpack_public_path__ + "static/media/no-results.a07656a9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/no-results.mp4
// module id = 848
// module chunks = 0